import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import Axios from 'axios';
import type { GetServerSidePropsContext } from 'next';

import type { TAxiosPaginatedResponseData, TError, TJSONEntity } from '@shared/lib/types';
import { API_PATH } from './const';

export const axiosInstance = Axios.create({
  baseURL: API_PATH,
  withCredentials: true,
  transformResponse: (data) => {
    if (typeof data !== 'string') {
      return data;
    }

    try {
      const parsedResponse = JSON.parse(data) as AxiosResponse<TJSONEntity> | TAxiosPaginatedResponseData | TError;

      if (parsedResponse.status === 'error') {
        return {
          message: (parsedResponse as TError).message,
          details: (parsedResponse as TError).details,
        };
      }

      const parsedData = (parsedResponse as AxiosResponse<TJSONEntity> | TAxiosPaginatedResponseData)?.data;

      if (Array.isArray(parsedData) && 'meta' in parsedResponse) {
        return {
          data: parsedData,
          meta: parsedResponse.meta,
        };
      }

      return parsedData;
    } catch {
      // todo add throwing error to rollbar. Now need to return data, because of receiving html form templates, which fails on json parsing
      return data;
    }
  },
});

export const getSSRRequestOptions = (context: GetServerSidePropsContext): AxiosRequestConfig => {
  const baseURL = `${process.env.NEXT_PUBLIC_API_HOST?.replace(/\/$/, '')}${process.env.NEXT_PUBLIC_API_PATH}`;
  const cookieHeader = Object.entries(context.req.cookies)
    .map(([key, value]) => `${key}=${value}`)
    .join(';');

  return {
    baseURL,
    headers: {
      Cookie: cookieHeader,
    },
  };
};
